import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useTimeZones() {
  const [loading, setLoading] = useState(true);
  const [timeZones, setTimeZones] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.time_zones.index)
      .then((response) => {
        setTimeZones(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, timeZones };
}
